import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      animation: ", " 1.4s ease-in-out infinite;\n\n      /* Some default value that looks fine waiting for the animation to kicks in. */\n      stroke-dasharray: 80px, 200px;\n      stroke-dashoffset: 0; /* Add the unit to fix a Edge 16 and below bug. */\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      animation: ", " 1.4s linear infinite;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";

var _ = function _(t) {
  return t;
},
    _t,
    _t2,
    _t3,
    _t4;

import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { chainPropTypes, deepmerge } from '@material-ui/utils';
import { unstable_composeClasses as composeClasses } from '@material-ui/unstyled';
import { keyframes, css } from '@material-ui/styled-engine';
import capitalize from '../utils/capitalize';
import useThemeProps from '../styles/useThemeProps';
import experimentalStyled from '../styles/experimentalStyled';
import circularProgressClasses, { getCircularProgressUtilityClass } from './circularProgressClasses';
var SIZE = 44;
var circularRotateKeyframe = keyframes(_t || (_t = _(_templateObject())));
var circularDashKeyframe = keyframes(_t2 || (_t2 = _(_templateObject2())));

var overridesResolver = function overridesResolver(props, styles) {
  var _extends2;

  var styleProps = props.styleProps;
  return deepmerge(_extends({}, styles[styleProps.variant], styles["color".concat(capitalize(styleProps.color))], (_extends2 = {}, _defineProperty(_extends2, "& .".concat(circularProgressClasses.svg), styles.svg), _defineProperty(_extends2, "& .".concat(circularProgressClasses.circle), _extends({}, styles.circle, styles["circle".concat(capitalize(styleProps.variant))], styleProps.disableShrink && styles.circleDisableShrink)), _extends2)), styles.root || {});
};

var useUtilityClasses = function useUtilityClasses(styleProps) {
  var classes = styleProps.classes,
      variant = styleProps.variant,
      color = styleProps.color,
      disableShrink = styleProps.disableShrink;
  var slots = {
    root: ['root', variant, "color".concat(capitalize(color))],
    svg: ['svg'],
    circle: ['circle', "circle".concat(capitalize(variant)), disableShrink && 'circleDisableShrink']
  };
  return composeClasses(slots, getCircularProgressUtilityClass, classes);
};

var CircularProgressRoot = experimentalStyled('span', {}, {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: overridesResolver
})(function (_ref) {
  var styleProps = _ref.styleProps,
      theme = _ref.theme;
  return _extends({
    /* Styles applied to the root element. */
    display: 'inline-block'
  }, styleProps.variant === 'determinate' && {
    transition: theme.transitions.create('transform')
  }, styleProps.color !== 'inherit' && {
    color: theme.palette[styleProps.color].main
  });
},
/* Styles applied to the root element if `variant="indeterminate"`. */
function (_ref2) {
  var styleProps = _ref2.styleProps;
  return styleProps.variant === 'indeterminate' && css(_t3 || (_t3 = _(_templateObject3(), 0)), circularRotateKeyframe);
});
var CircularProgressSVG = experimentalStyled('svg', {}, {
  name: 'MuiCircularProgress',
  slot: 'Svg'
})({
  /* Styles applied to the svg element. */
  display: 'block' // Keeps the progress centered

});
var CircularProgressCircle = experimentalStyled('circle', {}, {
  name: 'MuiCircularProgress',
  slot: 'Circle'
})(function (_ref3) {
  var styleProps = _ref3.styleProps,
      theme = _ref3.theme;
  return _extends({
    /* Styles applied to the `circle` svg path. */
    stroke: 'currentColor'
  }, styleProps.variant === 'determinate' && {
    transition: theme.transitions.create('stroke-dashoffset')
  });
},
/* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
function (_ref4) {
  var styleProps = _ref4.styleProps;
  return styleProps.variant === 'indeterminate' && css(_t4 || (_t4 = _(_templateObject4(), 0)), circularDashKeyframe);
});
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress =
/*#__PURE__*/
React.forwardRef(function CircularProgress(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiCircularProgress'
  });

  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutPropertiesLoose(props, ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var styleProps = _extends({}, props, {
    color: color,
    disableShrink: disableShrink,
    size: size,
    thickness: thickness,
    value: value,
    variant: variant
  });

  var classes = useUtilityClasses(styleProps);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return (
    /*#__PURE__*/
    React.createElement(CircularProgressRoot, _extends({
      className: clsx(classes.root, className),
      style: _extends({
        width: size,
        height: size
      }, rootStyle, style),
      styleProps: styleProps,
      ref: ref,
      role: "progressbar"
    }, rootProps, other),
    /*#__PURE__*/
    React.createElement(CircularProgressSVG, {
      className: classes.svg,
      styleProps: styleProps,
      viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
    },
    /*#__PURE__*/
    React.createElement(CircularProgressCircle, {
      className: classes.circle,
      style: circleStyle,
      styleProps: styleProps,
      cx: SIZE,
      cy: SIZE,
      r: (SIZE - thickness) / 2,
      fill: "none",
      strokeWidth: thickness
    })))
  );
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'primary'
   */
  color: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary']), PropTypes.string]),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,

  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(['determinate', 'indeterminate'])
} : void 0;
export default CircularProgress;